import React from "react";
import { Box, MenuItem, Select, TextField, Typography } from "@mui/material";
import RuleBlock from "./RuleBlock";
import WithTooltip from "./WithTooltip";
import { REFERENCE_OPTIONS } from "../constants";
import { onlyNumbers } from "../helpers";
import { useTheme } from "@mui/material/styles";

export default function DateRuleSection({
  selectedColumn,
  hasColumn,
  daysOffset,
  reference,
  updateData,
  openColumnModal,
  buttonSx,
  inputSx,
  selectSx,
  disabledSx,

  showErrors,
  isIncomplete,
  needsDays, 
  
  requiredError,
}) {

  const theme = useTheme();
  
  const shouldShowDays = reference === "before" || reference === "after";

  const fieldSx = {
    width: { xs: "100%", md: 320 },
    flexShrink: 0,
  };

  const showLocalError = showErrors && isIncomplete;
 
  const showRequiredError = requiredError;

  const referenceError =
    (showLocalError && !reference) ||
    (showRequiredError && !reference);

  const daysError =
    (showLocalError && needsDays && !daysOffset) ||
    (showRequiredError && needsDays && !daysOffset);

  const columnError =
    showRequiredError && !selectedColumn;

  return (
    <Box>
      <RuleBlock
        title="Regra por data"
        description="Configure disparos baseados em datas (ex: vencimento, renovação, etc)."
        buttonText={
          selectedColumn
            ? `Coluna: ${selectedColumn.title}`
            : "Selecionar coluna de data"
        }
        onClickButton={() => openColumnModal("dueDate")}
        buttonSx={{
          ...buttonSx(Boolean(selectedColumn)),
          ...(columnError && {
            backgroundColor: theme.palette.custom.red[100],
            color: theme.palette.custom.red[600],
            "&:hover": {
              backgroundColor: theme.palette.custom.red[200],
            },
          }),
        }}
        onClear={
          selectedColumn
            ? () =>
                updateData({
                  dueDateColumnId: null,
                  reference: "",
                  daysOffset: "",
                })
            : null
        }
      >
        {/* REFERÊNCIA */}
        <Box sx={fieldSx}>
          <WithTooltip
            enabled={hasColumn}
            title="Selecione uma coluna de data primeiro"
          >
            <Select
              fullWidth
              disabled={!hasColumn}
              displayEmpty
              value={reference}
              onChange={(e) =>
                updateData({
                  reference: e.target.value,
                  ...(e.target.value === "sameDay" && { daysOffset: "" }),
                })
              }
              error={referenceError}
              sx={{
                ...selectSx,
                ...(!hasColumn ? disabledSx : {}),
              }}
            >
              <MenuItem value="" disabled>
                Referência
              </MenuItem>

              {REFERENCE_OPTIONS.map((opt) => (
                <MenuItem key={opt.id} value={opt.id}>
                  {opt.title}
                </MenuItem>
              ))}
            </Select>
          </WithTooltip>

          {referenceError && (
            <Typography sx={{ color: "error.main", fontSize: 12, mt: 0.5 }}>
              Selecione uma referência
            </Typography>
          )}
        </Box>

        {/* DIAS */}
        {shouldShowDays && (
          <Box sx={fieldSx}>
            <TextField
              fullWidth
              disabled={!hasColumn}
              label="Dias"
              placeholder="Ex: 2"
              value={daysOffset}
              onChange={(e) =>
                updateData({
                  daysOffset: onlyNumbers(e.target.value),
                })
              }
              error={daysError}
              helperText={daysError ? "Informe os dias" : ""}
              sx={{
                ...inputSx,
                ...(!hasColumn ? disabledSx : {}),
              }}
            />
          </Box>
        )}
      </RuleBlock>
    </Box>
  );
}
